import { axiosInstances } from 'utilities/axios/Instances/axios.instances';
const getQuestions = async active => {
  const questions = await axiosInstances.withAuthToken().get(`/questions?active=${active}`);
  return questions?.data;
};

export const questionsService = {
  getQuestions
};
